
import { supabase } from '@/integrations/supabase/client';
import { SubscriptionUpdate } from '@/services/types/subscriptionTypes';

// Обновление статуса подписки
export const updateSubscriptionStatus = async (id: string, newStatus: 'active' | 'cancelled' | 'paused') => {
  try {
    console.log(`Обновление статуса подписки ${id} на ${newStatus}`);
    
    const { data, error } = await supabase
      .from('subscriptions')
      .update({ status: newStatus })
      .eq('id', id)
      .select();
      
    if (error) {
      console.error('Ошибка при обновлении статуса подписки:', error);
      return { success: false, error: error.message };
    }
    
    console.log('Подписка успешно обновлена:', data);
    return { success: true, data };
  } catch (err: any) {
    console.error('Непредвиденная ошибка при обновлении статуса подписки:', err);
    return { success: false, error: err.message };
  }
};

// Обновление подписки
export const updateSubscription = async (subscription: SubscriptionUpdate) => {
  try {
    const { id, ...updateData } = subscription;
    
    const { data, error } = await supabase
      .from('subscriptions')
      .update(updateData)
      .eq('id', id)
      .select();
      
    if (error) {
      console.error('Ошибка при обновлении подписки:', error);
      return { success: false, error: error.message };
    }
    
    console.log('Подписка успешно обновлена:', data);
    return { success: true, data };
  } catch (err: any) {
    console.error('Непредвиденная ошибка при обновлении подписки:', err);
    return { success: false, error: err.message };
  }
};

// Удаление подписки
export const deleteSubscription = async (id: string) => {
  try {
    const { data, error } = await supabase
      .from('subscriptions')
      .delete()
      .eq('id', id)
      .select();
      
    if (error) {
      console.error('Ошибка при удалении подписки:', error);
      return { success: false, error: error.message };
    }
    
    console.log('Подписка успешно удалена:', data);
    return { success: true, data };
  } catch (err: any) {
    console.error('Непредвиденная ошибка при удалении подписки:', err);
    return { success: false, error: err.message };
  }
};
